import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export default function testimonials () {

	// Skip containers already initialised (eg. re-running after an ACF
	// block preview refresh in the editor - see hook below)
	const swipers = document.querySelectorAll('section.testimonials .swiper:not(.swiper-initialized)');

	if (! swipers.length) return;



	// Init swiper
	swipers.forEach(function (container) {

		const section = container.closest('section');

		new Swiper (container, {
			modules: [Navigation],
			loop: false,
			slidesPerView: 1,
			navigation: {
				prevEl: section.querySelector('.swipe-prev'),
				nextEl: section.querySelector('.swipe-next'),
			},
		});

	});

}



/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on attribute change) without a page reload, so
	'DOMContentLoaded' only covers the first render - re-run init on every
	preview refresh too. ACF's block-preview JS may run in the iframe's own
	window or in the parent admin window depending on context, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=testimonials', testimonials);
}
